module.exports = __webpack_public_path__ + "img/startup.3559fef3.jpg";